// extracted by mini-css-extract-plugin
export default {"tx":"_58d03ab6bd","line":"_7c80780567"};